import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { effects as searchFiltersEffects } from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import {
  actions as searchMapActions,
  selectors as searchMapSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchMap.duck';
import { effects as searchPageEffects } from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';
import { selectors as searchSelectors } from '@rover/react-lib/src/redux/ducks/search.duck';

import StickyMap from './StickyMap';

type Props = {
  onMarkerClick: (index: number) => void;
};

const selector = (state) => ({
  isExpanded: searchMapSelectors.getIsExpanded(state),
  isSearchLoading: searchSelectors.getSearchIsLoading(state),
  center: searchSelectors.getCenterLatLng(state),
  zoomLevel: searchSelectors.getZoomLevel(state),
  baseTags: searchMapSelectors.getBaseEventTags(state),
  searchResults: searchSelectors.getSearchResults(state),
  showDynamicMap: searchMapSelectors.getShowDynamicMap(state),
});

const effects = {
  fireSearch: searchPageEffects.fireSearch,
  updateFilters: searchFiltersEffects.updateFilters,
};

const StickyMapContainer = (props: Props): JSX.Element => (
  <Connect
    actions={{
      toggleIsExpanded: searchMapActions.toggleIsExpanded,
    }}
    selector={selector}
    effects={effects}
  >
    {(connectedProps) => <StickyMap {...connectedProps} {...props} />}
  </Connect>
);

export default StickyMapContainer;
